/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ApiError,
    ProcessEventQueueDTO,
} from '../models';

/**
 * 
 */
export class ProcessEventQueueControllerApi extends runtime.BaseAPI {

    /**
     */
    async listEventsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<ProcessEventQueueDTO>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/process-queue`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async listEvents(initOverrides?: RequestInit): Promise<Array<ProcessEventQueueDTO>> {
        const response = await this.listEventsRaw(initOverrides);
        return await response.value();
    }

}
